import React from 'react';
import { useQuery } from '@common/hooks';
import { ENUM_QUERY } from '@common/graphql';

export function StateBadge({
  state,
  caption,
  statusIcons,
  statusLabel,
  rejectionReason,
  rejectionDetails,
  color,
  lastComment,
}: {
  state: string;
  caption?: React.ReactNode;
  statusIcons?: React.ReactNode;
  statusLabel?: string;
  rejectionReason?: string;
  rejectionDetails?: string;
  color?: string;
  lastComment?: React.ReactNode;
}) {
  const { loading, error, data } = useQuery(ENUM_QUERY, {
    variables: { key: 'OfferRejectionReasons' },
  });

  const rejectionReasonDescriptionByType = (
    rejectionType: string | undefined
  ) => {
    if (loading || error || !data) {
      return null;
    }
    if (!rejectionType) {
      return null;
    }

    return data.enum.find(({ name }) => rejectionType === name)?.description;
  };

  return (
    <>
      <div className="StateBadge">
        <div className="state">
          <span
            className={`State state color-${color}`}
            style={{ fontSize: 14 }}
          >
            {state}
          </span>{' '}
          {statusIcons}{' '}
          <span className="state-badge__status-label">{statusLabel}</span>
          {rejectionReason && (
            <div className={`reason color-${color}`}>
              <p>{rejectionReasonDescriptionByType(rejectionReason)}</p>
              {rejectionDetails && <p>{`"${rejectionDetails}"`}</p>}
            </div>
          )}
        </div>
        {lastComment}
        <div className="caption">{caption}</div>
      </div>
      <style jsx>
        {`
          .state-badge__status-label {
            font-size: 13px;
            font-weight: 400;
            text-transform: initial;
            vertical-align: top;
          }
          .StateBadge .state {
            font-weight: 800;
            font-size: 13px;
            line-height: 24px;
            text-transform: capitalize;
          }

          .StateBadge .caption {
            font-size: 12px;
            line-height: 24px;
            color: @colors[midnight-lighter];
            font-weight: 400;
          }

          .StateBadge .reason {
            margin-top: 0.5rem;
            font-size: 16px;
            line-height: 24px;
            font-weight: 400;
          }

          .StateBadge .state > .reason > p {
            margin: 0;
          }
        `}
      </style>
    </>
  );
}
